import type {NodeParameters} from "#graph/index"
import type {EditorNodeParameters} from "#graph/nodes/editor/types"
import {GraphNode} from "#graph/nodes/graph/graph-node"

export abstract class EditorNode<
    out Returns = unknown,
    in Context = unknown,
    out Parameters extends EditorNodeParameters = EditorNodeParameters,
    out ConstructorParameters extends NodeParameters = Parameters,
> extends GraphNode<Returns, Context, Parameters, ConstructorParameters> {}
